export default {
  // 단어
  'profile': '프로필',
  'user': '사용자',
  'login': '로그인',
  'logout': '로그아웃',
  'ID': '아이디',
  'PW': '비밀번호',
  'PW_confirm': '비밀번호 확인',
  'SC0010': '신용카드',
  'SC0030': '계좌이체',
  'SC0060': '휴대폰 결제',
  'Superadmin': '서비스',
  'Corporate': '코퍼레이트',
  'Basic': '베이직',
  'Free': '무료체험',
  'Email': '이메일',
  'name': '이름',
  'phone': '전화번호',
  'office_phone': '사무실 전화',
  'subscription_path': '가입경로',
  'windows': '윈도우',
  'Windows': '윈도우',
  'linux': '리눅스',
  'mac': '맥',
  'android': '안드로이드',
  'agent': '에이전트',
  'download': '다운로드',
  'manual': '메뉴얼',
  'service': '서비스',
  'payment': '결제',
  'manage': '관리',
  'manager': '관리자',
  'group': '그룹',
  'information': '정보',
  'threshold': '경고기준',
  'limit': '임계값',
  'alert': '경고',
  'setting': '설정',
  'device': '장치',
  'type': '유형',
  'add': '추가',
  'add_n': '{v} 추가',
  'remove': '제거',
  'delete': '삭제',
  'progress': '진행',
  'time': '시간',
  'hour': '시',
  'minute': '분',
  'second': '초',
  'device-in-group': '그룹에 속한 장치',
  'list-of': '{v} 목록',
  'total': '전체',
  'history': '이력',
  'registration': '신청',
  'statistics': '통계',
  'update': '연장',
  'renew': '갱신',
  'connected': '연결됨',
  'disconnected': '연결끊김',
  'running': '작동중',
  'sub-manager': '하위사용자',
  'execute': '실행',
  'cancel': '취소',
  'ea': '개',
  'WON': '원',
  'months': '개월',
  'years': '년',
  'back': '뒤로',
  'expire': '만료',
  'notify': '알림',
  'help': '도움말',
  'status': '상태',
  'program': '프로그램',
  'web': '웹',
  'proposal': '제안서',
  'brochure': '브로셔',
  'ios': 'iOS',
  'etc': '기타',
  'on-work': '준비중',
  'list-view': '리스트뷰',
  'card-view': '아이콘뷰',
  'live-view': '썸네일뷰',
  'delete-n': '{v} 삭제',
  'move-group-n': '{v} 그룹이동',
  'selected': '선택된',
  'accessable': '접근가능',
  'empty': '없음',
  'device_limit': '장치수 제한',
  'device_name': '장치 이름',
  'O/S': 'O/S',
  'edit': '편집',
  'refresh': '새로고침',
  'off-editmode': '편집모드 종료',
  'emptied_memo': 'ㅡ',
  'upper_group': '상위그룹',
  'all_device': '모든장치',
  'submit': '확인',
  'create': '생성',
  'delete_group': '그룹삭제',
  'delete_device': '장치삭제',
  'favorate': '즐겨찾기',
  'search': '검색',
  'by_user': '사용자별 {v}',
  'by_device': '장치별 {v}',
  'by_type': '유형별 {v}',
  'by_daily': '일별',
  'by_monthly': '월별',
  'alert_count': '경고 발생 횟수',
  'use_rate': '사용률',
  'rate': '비율',
  'use_count': '횟수',
  'select_date': '기간선택',
  'connect_count_of_remote': '원격제어 시도 횟수 추이',
  'count_of_alert': '경고 발생 횟수 추이',
  'chart': '차트',
  'date': '날짜',
  'host': '호스트',
  'viewer': '뷰어',
  'start_time': '시작 @:date',
  'end_time': '종료 @:date',
  'event_time': '발생일시',
  'login_time': '접속시간',
  'type_of_device': '장치유형',
  'alert_message': '경고메세지',
  'browser': '브라우저',
  'file_name': '파일이름',
  'size': '크기',
  'top10': '상위10',
  'change': '변경',
  'do_change': '변경하기',
  'advenced_auth': '2단계 인증',
  'department': '부서',
  'cowork_position': '직책',
  'timezone': '표준시간대',
  'date_format': '@:date 형식',
  'time_sec': '시간(초)',
  'auto_update': '자동갱신',
  'active': '활성화',
  'inactive': '비활성화',
  'permission': '권한',
  'target': '대상',
  'common': '공통',
  'web_manager': '웹매니저',
  'CS_manager': 'CS매니저',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': '라이센스',
  'regist_service': '@:service 신청',
  'update_service': '@:service 연장',
  'device_type': '제품유형',
  'device_vol': '장치 수',
  'period': '기간',
  'price': '가격',
  'total_price': '총 금액',
  'payment_type': '제품유형',
  'payment_method': '결제수단',
  'remark': '비고',
  'notice': '공지사항',

  // 메세지
  'no-selects': '선택된 항목이 없습니다.',
  'no-content': '해당되는 항목이 없습니다',
  'on_working': '준비중 입니다.',
  'not_save_warning': '저장하지 않는 내용은 반영되지 않습니다. 진행하시겠습니까?',
  'not_online_warning': '장치가 온라인 상태가 아닙니다.',
  'no_input_data': '입력한 내용이 없습니다.',
  'add_child_group': '"{name}"의 하위 그룹을 추가합니다.<br>그룹 이름을 입력해주세요.',
  'add_root_group': '"최상위"에 그룹을 추가합니다.<br>그룹 이름을 입력해주세요.',
  'duplication_group_name': '같은 이름의 그룹이 같은 위치에 있습니다.',
  'created_group': '그룹을 생성했습니다.',
  'please_select_group': '그룹을 선택해 주세요.',
  'confirm_delete_group': '그룹 삭제 시, 해당 그룹의 기기는 기본그룹으로 이동합니다.<br>삭제하시겠습니까?',
  'deleted_group': '그룹이 삭제되었습니다.',
  'all_device_has_no_child': '모든장치에 하위그룹을 포함할 수 없습니다.',
  'confirm_delete_device': `
    원격지 기기의 에이전트 프로그램이 로그아웃됩니다.<br>
    이후 기기를 다시 제어하시려면 최초 1회 수동 로그인을 해주셔야 합니다.<br>
    삭제 하시겠습니까?
    <br><br>
    대상: {name}
  `,
  'deleted_device': '장치가 삭제되었습니다.',
  'moved_device': '[{device}]이(가) [{group}]으로 이동하였습니다.',
  'moved_device_by': '[{device}]이(가) [{group}] 옆으로 이동하였습니다.',
  'moved_device_fail': '{name}은(는) 옮길 수 없습니다.',
  'deleted_device_count': '[{count}/{total}] 장치가 삭제되었습니다.',
  'no_order_warning': '그룹 순서 이동은 지원하지 않습니다. 오름차순으로 정렬됩니다',
  'delete_user_confirm': '해당 사용자를 삭제 하시겠습니까?',
  'user_active_changed': '"{name}"이(가) "{status}"로 변경되었습니다.',
  'deleted_user': '사용자가 삭제되었습니다.',
  'created_user': '사용자가 등록되었습니다.',
  'add_permission_of_group': `
    이 그룹의 권한을 부여하기 위해 아래의 상위그룹에 대한 권한이 필요합니다.
    <br><br>
    [{groups}]
    <br><br>
    허용하시겠습니까?
  `,
  'delete_permission_of_group': `
    이 그룹의 권한을 제거하기 위해 아래의 하위그룹에 대한 권한제거가 필요합니다.
    <br><br>
    [{groups}]
    <br><br>
    허용하시겠습니까?
  `,
  'please_select': '선택해 주세요.',
  'please_input': '입력해 주세요.',
  'please_select_device_type': '장치유형을 @:please_select',
  'please_select_alert_type': '경고 유형을 @:please_select',
  'please_input_alert_time': '진행 시간을 @:please_input',
  'please_input_alert_value': '임계값을 @:please_input',
  'permissions': {
    'deviceMonitor': '장치 모니터링',
    'CSRemoteControl': '원격 제어',
    'CSFileManager': '파일 전송',
    'modifyInformation': '정보 수정',
    'useFunction': '재시작/종료 기능',
    'viewReport': '통계/이력 보기',
    'CSRemoteView': '원격 보기',
    'CSDeviceManagement': '장치 관리',
    'CSUpdate': '업데이트',
    'CSThumbnailView': '썸네일 보기',
    'CSRestart': '재시작'
  },
  'added_device_in_group': '장치가 그룹에서 추가되었습니다.',
  'removed_device_in_group': '장치가 그룹에서 제거되었습니다.',
  'changed_group_info': '그룹정보가 변경되었습니다.',
  'remote': {
    'remote': {
      'title': '원격제어',
      'desc': '원격제어를 시작 하시겠습니까?'
    },
    'transfer': {
      'title': '파일전송',
      'desc': '파일전송를 시작 하시겠습니까?'
    },
    'reboot': {
      'title': '시스템 재시작',
      'desc': '해당 장치를 재부팅 하시겠습니까?'
    },
    'shutdown': {
      'title': '시스템 종료',
      'desc': '시스템을 종료 하시겠습니까?'
    },
    'preview': {
      'title': '스크린샷'
    },
    'detail': {
      'title': '상세정보'
    },
    'delete': {
      'title': '에이전트 삭제'
    },
    'wol': {
      'title': 'WOL 전원켜기',
      'desc': '"{device}" 장비를 하기 장비를 통하여 WOL로 켭니다. 장비를 선택하여 주십시오.'
    },
    'web': {
      'title': '원격제어(웹뷰어)'
    },
    'normal' : {
      'title': '원격제어(노멀뷰어)'
    }

  },
  'columns': {
    'alive': '연결',
    'actions': '기능',
    'alias': '장치이름',
    'memo': '메모',
    'last_connected_time': '에이전트 접속일',
    'group': '그룹',
    'connect': '접속'
  },
  'id_exist': '이미 존재하는 아이디입니다.',
  'reserved': {
    'ROOT': '기본그룹'
  },
  'audit-message': {
    '1': '원격제어 기능을 수행하였습니다.',
    '2': '파일관리자 기능을 수행하였습니다.',
    '3': '시스템을 재시작하였습니다.',
    '4': '시스템을 종료하였습니다.',
    '5': '에이전트를 최신버전으로 업데이트 하였습니다.',
    '11': '장치의 이름을 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '12': '장치에 메모를 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '21': '\'{old_value}\'에서 \'{new_value}\'로 그룹을 이동하였습니다.',
    '30': '{old_value} 에서 {new_value} 로 변경하였습니다.',
    '31': '예약(켜기) : {new_value}을 추가하였습니다.',
    '32': '예약(끄기) : {new_value}을 추가하였습니다.',
    '33': '예약(켜기) : {new_value}번째 설정을 제거 하였습니다.',
    '34': '예약(끄기) : {new_value}번째 설정을 제거 하였습니다.',
    '35': '리모컨 : {new_value} 실행하였습니다.'
  },
  'invalid_id': '올바른 아이디를 입력해 주세요',
  'name_requirement': '이름을 입력해 주세요.',
  'enter_new_password': '새 비밀번호 입력',
  'accessable_user_desc': '해당 그룹의 장치 접근 권한이 있는 하위 사용자 목록입니다.',
  'password_requirement': '비밀번호는 4~12자리 사이의 숫자, 알파벳, 특수문자만 허용됩니다.',
  'password_confirm': '비밀번호가 일치하지 않습니다.',
  'password_modified': '비밀번호가 변경되었습니다.',
  'password_modified_failed': '비밀번호 변경이 실패하였습니다.',
  'otp_reset_complete': 'OTP가 초기화 되었습니다.',
  'otp_reset_failed': 'OTP가 초기화에 실패하였습니다.',
  'forgot_desc': '아이디(이메일) 혹은 비밀번호를 찾을 수 있습니다.<br>해결이 안되시면 고객센터로 연락주시기 바랍니다.',
  'expired_desc': '계속 이용하시려면 기존 라이센스를 갱신 하시거나<br>삭제 할 디바이스를 선택 해 주시기 바랍니다.',
  'email-auth-wait': '이메일 인증을 하고 있습니다.<br>잠시만 기다려 주세요',
  'email-auth-already': '이메일 인증이 이미 완료되었습니다',
  'email-auth-fail': '이메일 인증에 실패하였습니다',
  'email-auth-success': '이메일 인증을 성공하였습니다.<br>로그인하여 주시기 바랍니다.',
  'login_description': '고객님이 가지고 있는 모든 PC나 스마트 기기, IoT 장비에 접속할 수 있습니다',
  'join_description': '링크미마인 회원가입을 축하합니다.<br>등록하신 이메일로 발송된 인증메일에서 ‘인증확인’을 클릭해주세요.',
  'go_login': '로그인하러가기',
  'add_manager_desc': `
    <div>1. 하위 사용자는 별도의 인증과정 없이 생성 후 바로 사용할 수 있습니다.</div>
    <div>2. 관리자 아이디는 하위 사용자 아이디로 로그인한 에이전트 장치를 모두 볼 수 있습니다.</div>
    <div>3. 각 하위 사용자에 대한 권한 및 볼 수 있는 장치그룹을 설정할 수 있습니다.</div>
  `,
  'payment_tax_desc1': '*부가세 포함이며, 1년 약정시 2개월분 금액이 할인됩니다.<br>** 제품 유형(라이센스) 변경 및 1년이상 장기 약정 희망시 고객 센터로 문의 바랍니다.<br>전화번호 : 070-7126-8663',
  'payment_tax_desc2': '세금계산서 필요시 입금 안내',
  'payment_tax_desc3': '전자결제를 진행하신 고객은 전자세금계산서 발급이 불가합니다.<br>세금계산서 발행을 원하실 경우 아래 계좌로 직접 입금하신 후 연락 주시기 바랍니다.<br>우리은행 (주) 링크미마인 1005-402-963384',
  'agreement': {
    'desc': '이용약관과 개인정보 수집/이용에 대한 동의를 해주세요.',
    'agree_all': '모두 동의 합니다',
    'agree_use': '이용약관 동의',
    'agree_use_context': `
      [서비스 이용약관]
      제1조 (목적)
      이 약관은 주식회사 링크미마인이 운영하는 인터넷 웹사이트(이하 링크미마인 또는 linkmemine.com)에서 제공하는 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 링크미마인 서비스와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
      제2조 (정의)
      ① 링크미마인 서비스란 컴퓨터 등 전자통신설비장치를 이용하여 이용자에게 유용한 각종 정보를 제공하는 인터넷 웹 사이트상의 관련 서비스를 말하며, 또한 인터넷 웹사이트 등을 운영하는 사업자의 의미로도 사용합니다. ② "서비스"란 이 약관 제4조에 정한 대로 링크미마인 서비스 사이트를 통하여 이용자를 위하여 무료 또는 유료로 제공하는 행위 또는 그 행위의 대상인 유·무형의 물건 자체를 의미합니다. ③ "이용자"란 링크미마인 서비스가 운영하는 웹사이트 등에 접속하여 이 약관에 따라서 링크미마인이 제공하는 서비스를 받는 회원 및 비회원을 말합니다. ④ "회원"이라 함은 링크미마인이 운영하는 웹사이트 등에 개인정보를 제공하여 회원등록을 하고 ID를 부여 받은 자로서, 링크미마인의 정보를 지속적으로 제공받고 서비스를 지속적으로 이용할 수 있는 자를 말합니다. ⑤ "비회원"이라 함은 "회원" 이외의 자를 의미 합니다.
      제3조 (약관의 명시와 개정)
      ① 링크미마인 서비스는 이 약관의 내용과 상호, 영업소 소재지, 대표자의 성명, 사업자등록번호, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 링크미마인 서비스의 초기 화면에 게시 합니다. ② 링크미마인 서비스는 약관의 규제 등에 관한 법률, 전자거래기본법, 전자 서명법, 정보통신망 이용촉진등에 관한 법률, 방문판매등에 관한 법률, 소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다. ③ 링크미마인 서비스는 약관을 개정할 경우에는 적용일자 및 개정사유 명시하여 현행약관과 함께 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. ④ 링크미마인 서비스의 약관을 개정할 경우에는 그 개정약관은 그 적용 일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에 링크미마인 관리자에 송신하여 링크미마인 관리자의 동의를 받은 경우에는 개정약관 조항이 적용됩니다. ⑤ 회원은 변경된 약관 내용에 동의하지 않으면 서비스 이용을 중단하고 회원으로부터 탈퇴할 수 있습니다. 단, 개정약관의 적용일 이후 상당 기간동안 계속적으로 서비스를 이용하는 경우 해당 회원은 약관의 변경에 동의한 것으로 간주될 수 있습니다. ⑥ 이 약관에서 정하지 아니한 내용과 이 약관의 해석에 관하여는 관계 법령 또는 상관례에 따릅니다.
      제4조 (서비스의 제공 및 변경)
      ① 링크미마인 서비스 는 다음과 같은 업무를 수행합니다. 1. 프로그램 또는 어플리케이션 서비스 정보 제공 2. 다양한 정보의 제공 3. 광고, 이벤트 행사 등 상품 또는 용역과 관련한 다양한 판촉 행위 4. 기타 이용자에게 유용한 부가 서비스 및 링크미마인 서비스가 정하는 업무 ② 링크미마인 서비스 는 재화의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화·용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 서비스의 내용 및 제공일자를 명시하여 현재의 서비스의 내용을 게시한 곳에 공지합니다. ③ 링크미마인 서비스가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 링크미마인은 이로 인하여 이용자가 입은 손해를 배상합니다. 단, 링크미마인의 고의 또는 과실이 없는 경우에는 책임을 부담하지 않습니다.
      제5조 (서비스의 중단)
      ① 링크미마인 서비스는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다. ② 제 1항에 의한 서비스 중단의 경우에는 링크미마인 서비스는 제8조에 정한 방법으로 이용자에게 통지합니다. ③ 링크미마인은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 링크미마인의 고의 또는 과실이 없는 경우에는 책임을 부담하지 않습니다.
      제6조 (회원가입)
      ① 이용자는 회원가입이 무료이며 링크미마인이 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다. ② 제 1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다. 1. 가입 신청자가 이 약관 제7조 제4항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조 제4항 에 의한 회원자격 상실 후 3년이 경과한 자입니다. 2. 등록 내용에 허위, 기재누락, 오기가 있는 경우 3. 기타 회원으로 등록하는 것이 링크미마인 서비스 기술상 현저히 지장이 있다고 판단되는 경우 ③ 회원가입 양식 작성시 이메일 확인 절차를 거친 후 회원으로 등록합니다. ④ 회원가입계약의 성립시기는 링크미마인의 승낙이 회원에게 도달한 시점으로 합니다. ⑤ 링크미마인의 회원은 회원으로 가입하는 동시에 "회원" 자격을 얻게 되며, 링크미마인에서 제공하는 다양한 서비스를 이용할 수 있습니다. ⑥ 링크미마인의 회원은 회원등록 시 가입한 이메일로 링크미마인 사이트에 자유롭게 접속할 수 있으며, 링크미마인 사이트에 접속하게 되면 ID로 승인 절차 후 이용하실 수 있습니다. ⑦ 회원은 등록한 회원정보에 변경이 있는 경우, 즉시 링크미마인에서 정하는 방법에 따라 그 변경사항을 링크미마인에게 통지하거나 수정하여야 합니다.
      제7조 (회원탈퇴 및 자격상실)
      ① 회원은 링크미마인에서 언제든지 탈퇴를 요청할 수 있으며, 회원이 탈퇴 요청을 하는 경우에는 링크미마인은 즉시 회원탈퇴에 필요한 조치를 취합니다. ② 회원이 다음 각 호의 사유에 해당하는 경우, 링크미마인은 회원에 대하여 일정한 서비스의 이용을 제한하거나 일정기간 회원자격을 정지시킬 수 있습니다. 1. 가입 신청 시에 허위 내용을 등록한 경우 2. 링크미마인 서비스를 이용하여 구입한 상품·용역 등의 대금, 기타 링크미마인 서비스 이용과 관련하여 회원이 부담하는 채무를 기일에 이행하지 않는 경우 3. 타인의 ID와 비밀번호 또는 그 개인정보를 도용한 경우 4. 링크미마인 서비스 이용을 방해하거나 그 정보를 도용, 타인의 명예를 손상시키거나 불이익을 주는 행위 등 전자거래질서를 위협하는 경우 5. 링크미마인 서비스 화면에 음란물을 게재하거나 음란사이트를 링크 시키는 경우 6. 링크미마인 서비스를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우 7. 기타 서비스 운영을 고의로 방해하는 행위를 하는 경우 ③ 링크미마인이 회원 자격을 제한·정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 링크미마인은 회원자격을 상실 시킬 수 있습니다. ④ 링크미마인이 회원자격을 상실 시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 소명할 기회를 부여합니다.
      제8조 (회원에 대한 통지)
      ① 링크미마인은 회원에 대한 통지를 하는 경우, 회원이 링크미마인에 제출한 전자우편 주소로 할 수 있습니다. ② 링크미마인은 불특정다수 회원에 대한 통지의 경우 1주일이상 링크미마인 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다.
      제9조 (ID 사이트의 약관 적용)
      링크미마인에서 운영하는 인터넷 웹사이트("linkmemine.com")사이트의 서비스 이용 시에는 해당사이트의 약관 적용을 받습니다.
      제10조 (개인정보보호)
      ① 링크미마인은 이용자의 정보 수집 시정보를 수집합니다. 사이트운영에 필요한 사항만을 필수사항으로 하며 그 외 사항은 선택사항으로 합니다. ② 링크미마인은 이용자의 개인식별이 가능한 개인정보를 수집 하는 때에는 반드시 당해 이용자의 동의를 받습니다. ③ 제공된 개인정보는 당해 이용자의 동의 없이 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 링크미마인이 집니다. 다만, 다음의 경우에는 예외로 합니다. 1. 배송업무상 배송업체에게 배송에 필요한 최소한의 이용자의 정보(성명, 주소, 전화번호)를 알려주는 경우 2. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우 ④ 링크미마인이 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에 개인정보관리 책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련 사항(제공 받는 자, 제공목적 및 제공할 정보의 내용) 정보통신망이용촉진 및 정보보호등에 관한 법률 제22조 제2항에서 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다. ⑤ 이용자는 언제든지 링크미마인이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 링크미마인은 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 링크미마인은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다. ⑥ 링크미마인은 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인 정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다. ⑦ 링크미마인 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다. ⑧ 링크미마인은 아래의 정보를 회사가 시행하는 제공기관과의 제휴서비스에 이용합니다. 1. 이용정보의 범위(성명, 주민등록번호, 직업, 전화번호 등) 2. 제공기관의 범위 가. 보험서비스 제휴 관련 손해보험사 및 생명보험회사 나. ID 제휴사이트간 공동 마케팅 수행 다. 기타 부가서비스 제공을 위한 제휴업체의 업무수행에 필요한 최소한의 범위 3. 개인정보 관리책임자 : 링크미마인 관리자(이메일 support@linkmemine.com)
      제11조 (링크미마인 서비스의 의무)
      ① 링크미마인 서비스는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다하여야 합니다. ② 링크미마인 서비스는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다. ③ 링크미마인 서비스는 상품이나 용역에 대하여 「표시·광고의 공정화에 관한 법률」제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다. ④ 링크미마인 서비스는 수신거절의 의사를 표시한 이용자에 대해서는 영리목적의 광고성 전자 우편을 발송하지 않습니다.
      제12조 (회원의 ID 및 비밀번호에 대한 의무 )
      ① 제10조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다. ② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다. ③ 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 링크미마인에 통보하고 링크미마인의 안내가 있는 경우에는 그에 따라야 합니다.
      제13조 (이용자의 의무)
      이용자는 다음 행위를 하여서는 안됩니다. 1. 신청 또는 변경 시 허위내용의 등록 2. 링크미마인에 게시된 타 정보의 변경 3. 링크미마인이 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시 4. 링크미마인 서비스 외 기타 제3자의 저작권 등 지적재산권에 대한 침해 5. 링크미마인 서비스 외 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위 6. 외설 또는 폭력적인 메시지·화상·음성 기타 공서양속에 반하는 정보를 몰에 공개 또는 게시하는 행위
      제14조 (링크미마인 서비스와 연결된 '사이트'와의 관계)
      ① 링크미마인과 연결된 '웹사이트'란 하이퍼링크(예: 하이퍼링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우를 말합니다. ② 링크미마인은 연결된 '웹사이트'가 독자적으로 제공 하는 재화·용역에 의하여 이용자와 행하는 거래에 대해서 보증 책임을 지지 않습니다.
      제15조 (저작권의 귀속 및 이용제한)
      ① 링크미마인이 작성한 저작물에 대한 저작권 기타 지적재산권은 링크미마인에 귀속합니다. ② 이용자는 링크미마인 서비스를 이용함으로써 얻은 정보를 링크미마인의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
      제 16조 (면책)
      ① 링크미마인 서비스는 천재지변, 불가항력 기타 합리적인 통제범위를 벗어난 사유로 인하여 서비스를 제공할 수 없는 경우에는 그에 대한 책임을 부담하지 않습니다. ② 링크미마인 서비스는 이용자의 귀책사유로 인하여 서비스를 제공할 수 없는 경우에는 그에 대한 책임을 부담하지 않습니다. ③ 링크미마인 서비스는 이용자가 서비스를 이용함으로써 기대되는 수익을 얻지 못하거나 서비스를 통해 얻은 자료를 이용하여 발생한 손해에 대해서는 책임을 부담하지 않습니다. ④ 이용자가 화면에 게재한 정보, 자료, 사실 등의 내용에 관한 신뢰도 또는 정확성에 대하여는 해당 이용자가 책임을 부담하며, 링크미마인 서비스는 내용의 부정확 또는 허위로 인해 이용자 또는 제3자에게 발생한 손해에 대하여는 아무런 책임을 부담하지 않습니다. ⑤ 링크미마인 서비스는 서비스이용과 관련하여 이용자의 고의 또는 과실로 인하여 이용자 또는 제3자에게 발생한 손해에 대하여는 아무런 책임을 부담하지 않습니다.
      제17조 (광고게재 등)
      ① 링크미마인은 이용자에게 최상의 서비스를 원활하게 제공하기 위하여 상업용 광고를 화면에 게재하거나 이메일 또는 DM(서신) 등을 이용하여 개별 이용자에게 보낼 수 있습니다. 단, 수신거절의 의사를 명백히 표시한 이용자에 대해서는 더 이상 이메일 또는 DM(서신) 등을 발송하지 않습니다. ② 링크미마인은 본 서비스를 통한 광고주의 판촉활동에 회원이 직접 참여함으로써 발생하는 손해에 대하여는 책임을 부담하지 않습니다.
      제18조 (분쟁해결)
      ① 링크미마인은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다. ② 링크미마인은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다. ③ 링크미마인은 이용자간에 발생한 분쟁은 전자거래기본법 제28조 및 동시행령 제10조에 의하여 설치된 전자거래분쟁조정위원회 의 조정에 따를 수 있습니다.
      제19조 (재판권 및 준거법)
      ① 링크미마인과 이용자간에 발생한 전자거래 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다. ② 링크미마인과 이용자간에 제기된 전자거래 소송에는 대한민국 법을 적용합니다.
      (부칙)
      본 약관은 2016년 04월 01일부터 시행합니다.
    `,
    'agree_privacy': '개인정보 수집/이용에 대한 동의',
    'agree_privacy_context': `
      [링크미마인 개인정보 수집/이용에 대한 동의] 

      1. 수집하는 개인정보의 항목
      2. 개인정보의 수집 별 이용목적
      3. 개인정보의 보유 및 이용기간
      
      
      1. 수집하는 개인정보의 항목
      '사이트'는 회원가입 절차 없이 이용하실 수 있는 컨텐츠와 원격지원을 위한 서비스 가입 후에 이용하실 수 있는 컨텐츠로 구성되어 있습니다.
      '사이트'의 회원제 서비스를 이용하시고자 할 경우 다음의 정보를 입력해주셔야 하며 선택항목을 입력하시지 않았다 하여 서비스 이용에 제한은 없습니다.
      1) 회원가입 시 수집하는 개인정보의 범위
      - 아이디(이메일), 이름, 전화번호, 생년월일, 메일수신여부
      
      
      
      2. 개인정보의 수집 별 이용목적
      ① '사이트'는 다음과 같은 목적을 위하여 개인정보를 수집하고 있습니다
      - 성명, 아이디, 비밀번호 : 회원제 서비스 이용에 따른 본인 식별 절차에 이용
      - 이메일주소, 전화번호 : 고지사항 전달, 본인 의사 확인, 불만 처리 등 원활한 의사소통 경로의 확보, 새로운 서비스, 신상품이나 이벤트 정보 등 최신 정보의 안내
      - 그 외 선택항목(생년월일 등) : 개인맞춤 서비스를 제공하기 위한 자료
      
      ② 단, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보 (인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.
      
      
      3. 개인정보의 보유 및 이용기간
      
      ① 귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기됩니다.
      단, 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 예외로 합니다.
      - 회원가입정보의 경우, 회원가입을 탈퇴하거나 회원에서 제명된 때
      - 대금지급정보의 경우, 대금의 완제일 또는 채권소멸시효기간이 만료된 때
      
      ② 위 개인정보 수집목적 달성시 즉시파기 원칙에도 불구하고 다음과 같이 거래 관련 권리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 전자상거래등에서의소비자보호에관한법률등에 근거하여 일정기간 보유합니다.
      - 계약 또는 청약철회 등에 관한 기록 : 5년
      - 대금결제 및 재화등의 공급에 관한 기록 : 5년
      - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
      
      ③ 귀하의 동의를 받아 보유하고 있는 거래정보등을 귀하께서 열람을 요구하는 경우 '사이트'는 열람, 확인 할 수 있도록 조치합니다.
    `
  },
  'deleted_device_history':'장치 삭제 이력',
  'device_excel_fail': '장치 리스트 EXCEL 생성에 실패했습니다.',
  
  'mode_simple': 'SIMPLE',
  'mode_normal': 'NORMAL',
  'icon_access': '접속중',
  'icon_online': '온라인',
  'icon_offline': '오프라인',
  'excel_button' : '엑셀'
}
